/* eslint-disable react/jsx-pascal-case */
import {
  CmpSelectBox,
  CmpButton,
  CmpDatePicker,
  CmpTextFieldEnter,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { fExecuteAPI } from "../../Server/Apis";
import { useSelector } from "react-redux";
import {
  Set_SliceEasyPutAway_SummaryObj,
  Set_SliceEasyPutAway_palletId,
  SliceEasyPutAway_Init,
} from "./SliceEasyPutAway";
import { fAlertToast, GetGitterColumns } from "../../Utility/Utilitys";
import EasyPutAway_BreadCrumbs from "./EasyPutAway_BreadCrumbs";
import useMediaQuery from "@mui/material/useMediaQuery";
import EasyPutawaySummaryModal from "./processComponent/EasyPutawaySummaryModal";
import { vRdxUserInfo } from "../../Redux/roStore";
import {
  PendingSummary_GETROW,
  easyPutAwayCardIdSummary_GETROW,
} from "../../Server/ApiV2";
import { Set_SliceEasyPutAway_HeadObj_SuggBin } from "./SliceEasyPutAway";
import { EasyPutAwayPendingCard } from "./processComponent/EasyPutAwayPendingCard";
import EasyPutawayCardDesign from "./processComponent/EasyPutawayCard";
import { EASY_PUT_AWAY_AUTO_FILLING_Flag } from "./EasyPutAwayAction";
export default function EasyPutAway() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const LocationFocusOnLoad = useRef(null);
  const [sSummaryGridRow, setSummaryGridRow] = useState([]);
  const vRdxUserInfoObj = vRdxUserInfo();
  // modal start

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    summaryHead: [],
    Bin: [],
  });
  // modal end

  const sEnterKeyObj = {
    key: "Enter",
  };
  const [sSummaryObj, setSummaryObj] = useState({
    ScanCardId: "",
  });

  const fSummary_OnChange = (e) => {
    setSummaryObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fOnKeyUp = async (e) => {
    if (e.key === "Enter") {
      fLoad(sSummaryObj.ScanCardId);
    }
  };

  const fLoad = async (xScanID = sSummaryObj.ScanCardId) => {
    if (xScanID == "") {
      fAlertToast("FAILED", "Card Id should not be empty");
      return;
    } else {
      var vSummaryObj = {
        PalletId: xScanID,
      };
      const iResp = await easyPutAwayCardIdSummary_GETROW(vSummaryObj);
      if (iResp?.status === 200) {
        if (iResp?.data?.ResultSet?.summaryHead?.length > 0) {
          setModalData(iResp?.data?.ResultSet);
          setShowModal(true);
        } else {
          fAlertToast("FAILED", "Card Id not found");
          return;
        }
      }
    }
  };

  const Get_Load_Grid_Data = async () => {
    var vSummaryObj = {
      v_UserCd: vRdxUserInfoObj.UserID,
    };

    const iResp = await PendingSummary_GETROW(vSummaryObj);

    if (iResp?.status === 200) {
      if (iResp?.data?.ResultSet?.length > 0) {
        const itemRows = iResp?.data?.ResultSet?.map((obj, i) => ({
          ...obj,
          id: i + 1,
          // A_PostDt: moment(obj.A_PostDt).format("DD/MM/YYYY"),
        }));
        setSummaryGridRow(itemRows);
      } else {
        setSummaryGridRow([]);
      }
    }
  };

  const fRowCLick = (item) => {
    // navigate("/EasyPutAwayDetail", {
    //   state: {
    //     GRNDocTyp: item?.row?.A_VocTyp,
    //     GrnDocNo: item?.row?.A_VocNo,
    //   },
    // });
  };

  useEffect(() => {
    Get_Load_Grid_Data(); 
    dispatch(
      SliceEasyPutAway_Init()
    );
  }, []);

  useEffect(() => {
    LocationFocusOnLoad.current?.focus();
  }, []);

  const [sSummaryGridColumn2, setSummaryGridColumn2] = useState([
    {
      field: "ItmCd",
      headerName: "Item Code",
      width: 100,
      hide: false,
    },
    {
      field: "Name1",
      headerName: "Item Name",
      width: 750,
    },
    {
      field: "GRNQty",
      headerName: "Grn Qty",
      width: 100,
    },

    {
      field: "PUTAWAYQty",
      headerName: "PutAwayQty",
      width: 100,
    },
    {
      field: "PendingQty",
      headerName: "Pending Qty",
      width: 100,
    },
  ]);

  // useEffect(() => {
  //   GetGitterColumns(
  //     setSummaryGridColumn2,
  //     "PENDING_PUTAWAY_SUMMARY",
  //     sSummaryGridColumn2
  //   );
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  const inventoryData = [
    {
      itemCode: "105208",
      itemName:
        "NOBEL BUILTIN MICROWAVE Black 34 LITRES Grill Convection TOUCH CONTROL",
      POQty: 3,
      GRNQty: 0,
      DiffQty: 3,
      totalCTNQty: 3,
      totalBaseQty: 3,
      totalCBM: 0.54,
      totalPallet: 1,
      QtyPerPallet: 1,
      BaseQtyPerPallet: 3,
    },
    {
      itemCode: "100347",
      itemName:
        "BOMPANI BUILTIN MICROWAVE Stainless Steel 34 LITRES Grill Convection Rotisserie New",
      POQty: 200,
      GRNQty: 0,
      DiffQty: 200,
      totalCTNQty: 200,
      totalBaseQty: 200,
      totalCBM: 32,
      totalPallet: 21,
      QtyPerPallet: 0.047619,
      BaseQtyPerPallet: 9.523809,
    },
    {
      itemCode: "103160",
      itemName: "BOMPANI Microwave Oven Silver 45 Litre",
      POQty: 235,
      GRNQty: 0,
      DiffQty: 235,
      totalCTNQty: 235,
      totalBaseQty: 235,
      totalCBM: 0,
      totalPallet: 1,
      QtyPerPallet: 1,
      BaseQtyPerPallet: 235,
    },
  ];
  return (
    <div className="container-fluid my-3">
      <div className="Breadcrumbs">
        <EasyPutAway_BreadCrumbs />
      </div>
      <div className="Instant-picking-head">
        <Grid container spacing={2} className="align-items-center">
          <Grid item lg={4} md={4} xs={12} className="bintransfer-data-date">
            <CmpTextFieldEnter
              xref={LocationFocusOnLoad}
              xLabelText={"Scan Card Id"}
              xVariant={"outlined"}
              xValue={sSummaryObj.ScanCardId}
              xOnChange={(event) => fSummary_OnChange(event)}
              xReadOnly={false}
              xType={"text"}
              xName={"ScanCardId"}
              xOnKeyUp={(e) => {
                fOnKeyUp(e);
              }}
              xOnEnter={(e) => {
                fOnKeyUp(sEnterKeyObj);
              }}
              xSmShow={!!vMediaQuery}
              xSize="small"
            />
          </Grid>

          <Grid
            item
            lg={2}
            md={4}
            xs={12}
            className={
              vMediaQuery ? "hide-content" : "bintransfet-data-load-btn"
            }
          >
            <CmpButton
              xbtnName="Load"
              xOnClick={() => {
                fLoad();
              }}
              xVariant="contained"
              xSize="small"
            />
          </Grid>
        </Grid>

        <EasyPutawayCardDesign items={sSummaryGridRow} />
        {/* {sSummaryGridRow?.length > 0 && (
          <Box>
            <Grid
              container
              spacing={{ xs: 0, md: 1 }}
              columns={{ xs: 12, sm: 12, md: 12 }}
              className="EasyPutAwayPendingCard mt-3"
            >
              {sSummaryGridRow?.map((obj, index) => (
                <Grid item xs={12} sm={12} md={6} key={index}>
                  <EasyPutAwayPendingCard 
                    ItmCd={obj.ItmCd}
                    Name1={obj.Name1}
                    GRNQty={obj.GRNQty}
                    PUTAWAYQty={obj.PUTAWAYQty}
                    PendingQty={obj.PendingQty}
                    onClick={() => {
                      console.log("asdadsas", obj);
                      let e = {
                        row: obj,
                      };
                      fRowCLick(e);
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        )} */}
      </div>
      {modalData.summaryHead.length > 0 && (
        <EasyPutawaySummaryModal
          xOpen={showModal}
          fCloseEasyPutawaySummaryModal={() => {
            setShowModal(false);
          }}
          xTitle="Card ID Detail"
          GRNNo={modalData?.summaryHead[0]?.grnno}
          GRNDate={modalData?.summaryHead[0]?.PostDt}
          Loaction={modalData?.summaryHead[0]?.locname}
          PalletId={modalData?.summaryHead[0]?.palletid}
          CardId={modalData?.summaryHead[0]?.cardId}
          ItemCd={modalData?.summaryHead[0]?.ItmCd}
          ItemName={modalData?.summaryHead[0]?.Name2}
          ModalCd={modalData?.summaryHead[0]?.Model}
          RefNo={modalData?.summaryHead[0]?.SuppRefNo1}
          GRNQty={modalData?.summaryHead[0]?.BaseQty}
          PutAwayQty={modalData?.summaryHead[0]?.PutAwayQty}
          BalanceQty={
            Number(modalData?.summaryHead[0]?.BaseQty) -
            Number(modalData?.summaryHead[0]?.PutAwayQty)
          }
          modalDataBin={modalData?.Bin}
          onClick={(obj) => {
            if (
             ( Number(modalData?.summaryHead[0]?.BaseQty) -
              Number(modalData?.summaryHead[0]?.PutAwayQty)  == 0)
            ) {
              fAlertToast("INFO", "BalanceQty is zero");
              return
            } else {
              navigate("/EasyPutAwayDetail", {
                state: {
                  GRNDocTyp: modalData.summaryHead[0]?.VocTyp,
                  // GRNDocTyp:'WG001',
                  GrnDocNo: modalData.summaryHead[0]?.grnno,
                },
              });
              dispatch(
                Set_SliceEasyPutAway_HeadObj_SuggBin({
                  SuggBin: obj.binName,
                  SuggBinCd: obj.binCode,
                })
              );
              if (EASY_PUT_AWAY_AUTO_FILLING_Flag()) {
                dispatch(
                  Set_SliceEasyPutAway_palletId(
                    modalData?.summaryHead[0]?.palletid
                  )
                );
              }
            }
          }}
        />
      )}
    </div>
  );
}
